const messages = {
    ru: {
        main: {
            appName: 'БАХОЛАШ',
            search: 'Поиск',
            logOut: 'Выйти',
            number: '№',
            send: 'Жўнатиш',
            searchStatus: 'Выберите статус',
            clearAllCaches: 'Очистить все кеши'
        },
        action: {
            saveAndCreateNew: 'Сохранить и создать новый',
            add: 'Добавить',
            view: 'Посмотреть',
            edit: 'Редактировать',
            delete: 'Удалить',
            save: 'Сохранить',
            savePrice: 'Янги нархни киритиш',
            saveAndApprove: 'Сохранить и Утвердить',
            annul: 'Аннулировать',
            cancel: 'Отменить',
            next: 'Следующий',
            prev: 'Предыдущий',
            filter: 'Филтер',
            excel: 'Excel',
            draft: 'Проект',
            pay: 'Оплатить',
            sendSms: 'Отправить СМС',
            enterBankLoginAndPassword: 'Банк введите логин и пароль',
            addManually: 'Добавить вручную'
        },
        dropzone: {
            defaultMessage: 'Перетащите сюда файлы для загрузки!',
            maxFilesExceeded: 'Вы не можете загружать больше файлов.',
            cancelUpload: 'Отменить',
            cancelUploadConfirmation: 'Вы уверены, что хотите отменить загрузку?',
            removeFile: 'Удалить',
            removeFileConfirmation: 'Вы уверены, что хотите удалить файл?'
        },
        company: {
            name: 'Компания',
            licenseAdd: 'Компанияга янги лицензия қўшиш',
            insuranceAdd: 'Компанияга янги суғурта қўшиш',
            certificateAdd: 'Компанияга янги сертификат қўшиш',
            preciousMetalsStonesAdd: 'Компанияга металлар ва қимматбаҳо учун лицензия қўшиш',
            add: {
                title: 'Компания профайли қўшиш'
            },
            edit: {
                title: 'Компания профайли ўзгартириш'
            },
            profile: {
                code: 'C',
                label: 'Компания профайли'
            },
            license: {
                code: 'CL',
                label: 'Компания лицензияси тўғрисида маълумот'
            },
            insurance: {
                code: 'CI',
                label: 'Компания суғуртаси тўғрисида маълумот'
            },
            certificate: {
                code: 'CС',
                label: 'Компания сертификати тўғрисида маълумот'
            },
            workingPreciousMetalsStones: {
                code: 'PMS',
                label: 'Қимматбаҳо металлар ва қимматбаҳо тошлар билан ишлаш учун лицензия'
            },
            validation: {
                name: 'Компания номини киритинг!',
                nameMaxLength: 'Компания номи 255 символдан ошмаслиги керак!',
                shortName: 'Компания қисқартирилган номини киритинг!',
                shortNameMax: 'Компания қисқартирилган номи 255 символдан ошмаслиги керак!',
                description: 'Компания таснифини киритинг!',
                descriptionMax: 'Компания таснифи 255 символдан ошмаслиги керак!',
                address: 'Компания манзилини киритинг!',
                addressMax: 'Компания манзили 255 символдан ошмаслиги керак!',
                phoneNumber: 'Компания телефон1ни киритинг!',
                phoneNumber1: 'Компания телефон1ни1 киритинг!',
                email: 'Е-майлни киритинг!',
                emailConfirm: 'Е-майлни форматини тугри киритинг!',
                webSite: 'Веб сахифасини киритинг!',
                accountNumber: 'Хисоб рақамини киритинг!',
                accountNumberConfirm: 'Хисоб рақам 20 символдан кам бўлмаслиги керак!',
                identificationNumber: 'ИНН рақамини киритинг!',
                identificationNumberConfirm: 'ИНН рақам 9 символдан кам бўлмаслиги керак!',
                interBranchTurnover: 'МФО рақамини киритинг!',
                interBranchTurnoverConfirm: 'МФО рақам 5 символдан кам бўлмаслиги керак!',
                xxtut: 'ХХТУТ рақамини киритинг!',
                xxtutConfirm: 'ХХТУТ рақам 5 символдан кам бўлмаслиги керак!',
                bankName: 'Банк номини киритинг!',
                director: 'Илтимос директорни танланг!',
                regNum: 'Регистрация рақамини киритинг!',
                regNumConfirm: 'Регистрация рақами 255 символдан ошмаслиги керак!',
                serialNum: 'Хисоб сериясини киритинг!',
                serialNumConfirm: 'Хисоб серияси 255 символдан ошмаслиги керак!',
                dataNum: 'Рақамини киритинг!',
                dataNumConfirm: 'Рақами 255 символдан ошмаслиги керак!',
                giveName: 'Ким тамонидан берилганни киритинг!',
                giveNameConfirm: 'Ким тамонидан берилган 255 символдан ошмаслиги керак!',
                startDate: 'Берилган санасини киритинг!',
                endDate: 'Амал қилиш муддатини киритинг!',
                province: 'Введите регион!',
                region: 'Введите район!',
            },
            field: {
                docCompanyLogo: 'Компания Logo',
                name: 'Компания номи',
                shortName: 'Компания қисқартирилган номи',
                nameRu: 'Компания номи (RU)',
                description: 'Компания таснифи',
                address: 'Компания манзили',
                phoneNumber1: 'Компания телефон1',
                phoneNumber2: 'Компания телефон2',
                email: 'Е-майл',
                webSite: 'Веб сахифаси',
                accountNumber: 'Хисоб рақами',
                identificationNumber: 'ИНН',
                interBranchTurnover: 'МФО',
                xxtut: 'ХХТУТ',
                bankName: 'Банк номи',
                director: 'Директор',
                docCompanyCertificate: 'Гувохнома нусхасини юкланг',
                hasEsp: 'ЭЦП (Ҳа / Йўқ)',
                companyEdit: 'Ўзгартириш',
                companyAdd: 'Қўшиш',
                companyCreate: 'Янгидан қўшиш',
                companyCertificatePicture: 'Гувохнома нусхасини юкланг',
                regNum: 'Регистрация рақами',
                serialNum: 'Хисоб серияси',
                dataNum: 'Рақами',
                giveName: 'Ким тамонидан берилган',
                startDate: 'Берилган санаси',
                endDate: 'Амал қилиш муддати',
                companyLicensePicture: 'Лицензия нусхасини юкланг',
                companyInsurancePicture: 'Суғурта нусхасини юкланг',
                companyCertificatePictureFile: 'Сертификати нусхасини юкланг',
                leaderStartDate: 'Директор бўлган санаси',
                preciousMetalsStonesPicture: 'Қимматбаҳо металлар ва қимматбаҳо тошлар билан ишлаш учун лицензия нусхасини юкланг',
                province: 'Провинция',
                region: 'Район',
                qqs: 'НДС (Да / Нет)'
            }
        },
        client: {
            name: 'Клиенты',
            titleListPhysical: 'Список лиц',
            titleListLegal: 'Список юридических лиц',
            titleAddEditPhysical: 'Физическое лицо справки',
            titleAddEditLegal: 'Юридическую личность справки',
            titleEditView: 'Клиент справки',
            add: {
                titlePhysical: 'Физическое лицо справок введите',
                titleLegal: 'Юридическую личность справок введите'
            },
            physical: {
                code: 'P',
                label: 'Физическое лицо'
            },
            legal: {
                code: 'L',
                label: 'Юридическое лицо'
            },
            action: {
                addApi: 'Добавлять (паспорт)'
            },
            field: {
                fullName: 'Ф.И.О',
                address: 'Адрес',
                clientType: 'Тип',
                createdDate: 'Киритилган сана',
                updatedDate: 'Ўзгартирилган сана',
                createdBy: 'Томонидан яратилган',
                action: 'Жараён',
                lastName: 'Фамилияси',
                firstName: 'Исми',
                midName: 'Отасининг исми',
                province: 'Вилояти',
                region: 'Тумани',
                phone: 'Телефон рақами',
                passportNumber: 'Паспорт серияси ва рақами',
                passportDate: 'Паспорт берилган сана',
                passportGivePlace: 'Ким томондан берилган',
                organizationType: 'Ташкилот',
                bankType: 'Банк тури',
                departmentType: 'Бошқарма тури',
                lLastName: 'Рахбарнинг фамилияси',
                lFirstName: 'Рахбарнинг исми',
                lMidName: 'Рахбар отасининг исми',
                firmName: 'Ташкилот номи',
                position: 'Лавозими',
                lAddress: 'Ташкилот манзили',
                accountNumber: 'Хисоб рақами',
                identificationNumber: 'ИНН',
                mFO: 'МФО',
                bankMFOName: 'Банк номи',
                email: 'Е-майл',
                soleTaxPayer: 'Ягона солиқ тўловчи',
                allowedAreas: 'Рухсат этилган худудлар',
                birthDate: 'Мижоз тўғилган санаси',
                passportDateValid: 'Паспорт амал қилиш муддати',
                pinflNumber: 'Персональный идентификационный номер физического лица (ПИНФЛ 14 цифр)'
            },
            validation: {
                lastName: 'Фамилиясини киритинг!',
                firstName: 'Исмини киритинг!',
                midName: 'Отасини исмини киритинг!',
                firmName: 'Ташкилот номини киритинг!',
                province: 'Вилоятни танланг!',
                region: 'Туманни танланг!',
                phone: 'Телефон рақамини киритинг!',
                pinflNumber: 'Ошибка формата ПИНФЛ!',
                passportNumber: 'Паспорт серияси ва рақамини киритинг!',
                passportDate: 'Паспорт берилган санани киритинг!',
                passportGivePlace: 'Ким томондан берилганни киритинг!',
                address: 'Манзилини киритинг!',
                minText: 'Ушбу майдон камида ',
                minValid: ' та белгидан иборат бўлиш керак!',
                maxText: 'Ушбу майдон ',
                maxValid: ' та белгидан иборат бўлиш керак!',
                accountNumber: 'Хисоб рақамини киритинг!',
                identificationNumber: 'ИННни киритинг!',
                mFO: 'МФО ни киритинг!',
                bankMFOName: 'Банк номини киритинг!',
                email: 'Е-майлни киритинг!',
                organizationType: 'Ташкилотни танланг!',
                bankType: 'Банк турини танланг!',
                departmentType: 'Бошқарма турини танланг!',
                position: 'Лавозимини киритинг!',
                birthDate: 'Мижоз тўғилган санасини киритинг!',
                passportDateValid: 'Паспорт амал қилиш муддатини киритинг!'
            }
        },
        user: {
            list: {
                code: 'П',
                label: 'Пользователи'
            },
            listTitle: "Список пользователей",
            addNew: "Добавить пользователя",
            titleEdit: 'Изменить пользователя',
            viewUserInfo: 'Фойдаланувчи маълумотлари кўриш',
            editUserInfo: 'Изменение данных пользователя',
            addUserInfo: 'Добавить пользователя',
            name: 'Пользователи',
            field: {
                fullName: 'Ф.И.О',
                lastName: 'Фамилию',
                firstName: 'Имя',
                midName: 'Отчество',
                dateOfBirth: 'Дату рождения',
                address: 'Адрес',
                province: 'Регион',
                region: 'Район',
                email: 'Электронной почты',
                mobilePhone: 'Мобильный телефон',
                homePhone: 'Домашнего телефона',
                pinflNumber: 'Персональный идентификационный номер физического лица (ПИНФЛ 14 цифр)',
                password: 'Текущий пароль',
                newPassword: 'Новый пароль',
                passwordConfirm: 'Повторите новый пароль',
                administrationType: 'Тип управления',
                username: 'Логин',
                identificationNumber: "ИНН",
                theEmployeesServiceOrganization: 'Организация обслуживания работника:',
                roleNames: 'Роль',
                userProvinces: 'Провинция, прикрепленная к управляющему',
                info: "описание",
                status: 'Статус',
                toAdd: 'добавить',
                attachRegionsToTheManager: 'Прикрепите регионы к менеджеру',
            },
            validation: {
                lastName: 'Введите фамилию!',
                firstName: 'Введите  имя!',
                midName: 'Введите очества!',
                dateOfBirth: 'Выберите дату рождения!',
                address: 'Введите адрес!',
                province: 'Введите регион!',
                region: 'Введите район!',
                email: 'введите адрес электронной почты!',
                homePhone: 'Введите номер домашнего телефона!',
                mobilePhone: 'Введите мобильный телефон!',
                pinflNumber: 'Ошибка формата ПИНФЛ!',
                password: 'Введите текущий пароль ',
                newPassword: 'Введите Новый пароль ',
                passwordConfirm: 'Повторите новый пароль',
                username: 'Введите Логин!',
                identificationNumber: 'Введите ИНН !',
                administrationType: 'Введите Тип управления',
                theEmployeesServiceOrganization: 'Выберите организацию обслуживания работника!',
                info: "написать описание",
                serialNum: 'Хисоб сериясини киритинг!',
                dataNum: 'Рақамини киритинг!',
                beginDate: 'Сана(дан)',
                endDate: 'Сана(гача) танланг',
                giveName: 'Ким тамонидан берилганни киритинг!',
            }
        },
        realEstate: {
            name: 'Недвижимость',
            titleList: 'Список недвижимости',
            titleListNotorious: 'Список недвижимости (Нотурар жой)',
            titleListResidential: 'Список недвижимости (Турар жой)',
            titleAddEditNotorious: 'Оценка недвижимости (Нотурар жой)',
            titleAddEditResidential: 'Оценка недвижимости (Турар жой)',
            titleEAppraisalRealEstateView: 'E-Baxolash посмотреть недвижимость',
            add: {
                title: 'Введите данные о недвижимости'
            },
            edit: {
                title: 'Редактировать недвижимость'
            },
            view: {
                title: 'Посмотреть недвижимость',
                eAppraisalTitle: 'E-Baxolash: Общая информация о недвижимости'
            },
            delete: {
                title: 'Удалить'
            },
            report: {
                title: 'Отчет PDF',
                titleQrCode: "Отчет PDF QR Code",
                titleWord: "Отчет Word",
                titleWordQrCode: "Отчет Word QR Code",
                titleContractWord: "Договор Word",
                titleContractWordQrCode: "Договор Word QR Code",
                titleContractPdf: "Договор Pdf",
                titleContractPdfQrCode: "Договор Pdf QR Code",
                reportNotSignedAndNoQrCodesPdf: "Отчет PDF(другой)"
            },
            field: {
                name: 'Объект',
                ownerClient: 'Владелец недвижимости',
                address: 'Адрес',
                addressAddEdit: 'Адрес недвижимости',
                approachMethods: 'Методы подхода',
                regPlace: 'Место регистрации',
                evaluatedAmount: 'Оцененная сумма',
                status: 'Статус',
                createdDate: 'Дата добавления',
                createdByAndDate: 'Создано / Дата добавления',
                createdBy: 'Создано',
                action: 'Процесс',
                withLetterOfAttorney: 'С доверенностью / Есть ли заказы другой организации?',
                withLetterOfAttorneyOwner: 'С доверенностью / Владелец заказа другой организации',
                evaluationPurpose: 'Цель оценки',
                evaluationRespectiveType: 'Соответствующий тип недвижимости',
                cadastreNumber: 'Кадастровый номер недвижимости',
                cadastreSection: 'Выберите тип кадастрового строения',
                province: 'Выберите регион',
                region: 'Выберите район',
                mibDebtorName: 'Имя должника',
                mibLetterNumber: 'Номер контактного письма',
                mibLetterDate: 'Дата подачи заявки',
                mibRegion: 'Региональное отделение исполнительного бюро',
                areaTotal: 'Общая площадь недвижимости(кв. м)',
                areaUnderConstruction: 'Строящаяся недвижимость(кв. м)',
                areaUseful: 'Недвижимость. Полезная площадь(кв. м)',
                valueType: 'Выберите тип значения, для которого должно быть определено свойство',
                propertyType: 'Форма собственности',
                evaluator: 'Оценщик',
                director: 'Директор',
                contractAmount: 'Сумма контракта',
                landComparison: 'Расчет рыночной стоимости земельного участка',
                landCapitalization: 'Расчет рыночной стоимости земельного участка (путем капитализации ставки земельного налога)',
                landCapitalizationTitle: 'Расчет рыночной стоимости земельного участка методом капитализации',
                docsToSubmit: 'Документы для оценки недвижимости',
                docPassport: 'Копия паспорта',
                docActOfSale: 'Акт',
                docDecision: 'Копия решения',
                docPlaylist: 'Лист исполнения',
                docBalance: 'Информация о балансе',
                docCadastre: 'Кадастровая документация',
                docApplication: 'Заявка',
                docDocuments: 'Письмо-заявление',
                docBuildingPhotos: 'Фотографии здания',
                docPrivatizationLetter: 'Письмо комиссии по оценке',
                docPrivatizationCommissionOrder: 'Приказы и протоколы приватизационной комиссии',
                docOwnershipCertificate: 'Свидетельство о праве собственности',
                buildingsToEvaluate: 'Введите здания для оценки',
                addBuilding: 'Добавить здание',
                checkPaymentFiles: 'Акт, счет, договор и обязанности',
                checkPaymentFilesMib: 'Акт и счет-фактура',
                evaluatorIdea: 'Мнение эксперта по идентификации',
                evaluatorRestrictiveTerms: 'Оценочное заключение об ограничительных условиях',
                category: 'Категория',
                docsSubmitted: 'Документы, поданные на оценку недвижимости',
                buildingDocsSubmitted: 'Документы, представленные для оценки зданий',
                rejectText: 'Причина отмены',
                locationText: 'Место нахождения',
                letterNumberText: 'Письмо №: ',
                invoiceNumberText: 'Контракт №: ',
                reportNumberText: 'Отчетность №: ',
                buildingCategory: 'Выберите категорию недвижимости',
                basicInformation: 'Основная информация о недвижимости',
                buildingType: 'Цель использования',
                microRegion: 'Выберите пункт назначения',
                repairConditions: 'Состояние ремонта',
                constructiveElement: 'Тип конструкции',
                storey: 'Количество этажей',
                floor: 'Этаж',
                builtYear: 'Год постройки',
                ownerPhoneNumber: 'Телефон владельца недвижимости',
                agent: 'Агент',
                specialComfort: 'Раздельные удобства',
                constructionCompletion: 'Завершение строительства (%)',
                architecturalStyle: 'Архитектурный стиль',
                tenderContractDate: 'Дата заключения контракта',
                tenderContractNumber: 'Число №',
                separateBuilding: 'Отдельное здание',
                admin: 'Администратор',
                area: 'Площадь',
                isFixByIndexLabel: 'Киёсий ёндашув индекс буйича тузатиш бериш',
                transportPlace: 'Автотураргоҳ мавжудлиги',
                ownerName: 'Мулк эгаси',
                ownerInn: 'Мулк эгаси ИНН',
                landLeaseEnabled: 'Рассчитать стоимость права аренды земельного участка',
                powerOfAttorneyNumber: 'Номер доверенности',
                powerOfAttorneyDate: 'Дата доверенности',
                landOwnerEnabled: 'Нет права собственности на земельный участок',
                housingType: 'Тип жилья',
                percentage: 'Фоиз',
                constructionCompletionDoc: 'Қурилиш тугаланганлик фоизи кўрсатилган ҳужжатни юкланг',
                evlTotalArea: 'Кўчмас мулк умумий майдон(кв. м)',
                hasTotalArea: 'Умумий майдондан хисоблаш',
                ownerPinflOrInn: 'Введите номер ПИНФЛа или ИНН владельца'
            },
            category: {
                notorious: {
                    code: 'Н',
                    label: 'Нежилое помещение'
                },
                residential: {
                    code: 'Т',
                    label: 'Жилое помещение'
                }
            },
            plus: {
                category: {
                    notorious: {
                        code: 'Н(+)',
                        label: 'Нежилое помещение (Оценка плюс)'
                    },
                    residential: {
                        code: 'Т(+)',
                        label: 'Жилое помещение (Оценка плюс)'
                    }
                },
                sendFixError: {
                    title: 'Камчиликга юбориш',
                    description: 'Камчилик сабабини киритинг.',
                    upload: 'Камчиликни юклаш'
                }
            },
            approach: {
                expense: 'Расходный подход',
                income: 'Доходный подход',
                comparative: 'Сравнительный подход',
                regression: 'Регрессионный подход',
                newComparative: 'Новый сравнительный подход'
            },
            createType: {
                ourselves: 'Сами',
                online: 'E-Baxolash сайт',
                android: 'Android',
                apiMib: 'API MIB',
                api_bank: 'API BANK',
                api_backend: 'API BACKEND',
                api_online: 'API ONLINE',
                api_exarid: 'API E-XARID',
                expert2: 'Эксперт 2',
                online_plus: 'E-Baxolash +',
                real_soft: 'Real Soft',
                apiEMonitoring: 'E-Мониторинг'
            },
            status: {
                notReady: 'Не готово',
                pending: 'На рассмотрение',
                assignedToEvaluator: 'Прикреплен к оценщику',
                notFullyEvaluated: 'Частично оценен',
                evaluated: 'Оценен',
                confirmed: 'Подтвержден',
                rejected: 'Отклонено',
                sentToComplement: 'Прикреплено к наполнителю',
                inIdentification: 'В Идентификации',
                errorInPrice: 'Ошибка цены',
                open: 'Янги',
                inCorrection: 'База камчиликга юборилди'
            },
            valueType: {
                market: 'Рыночная стоимость',
                nonMarket: 'Цена отличается от рыночной'
            },
            validation: {
                name: 'Пожалуйста, введите название объекта',
                ownerClient: 'Пожалуйста, выберите владельца собственности',
                withLetterOfAttorneyOwner: 'Пожалуйста, выберите другого владельца организации',
                approachMethods: 'Пожалуйста ёндашув усул(лар)ини танланг',
                evaluationPurpose: 'Выберите цель оценки',
                cadastreNumber: 'Пожалуйста, введите кадастровый номер недвижимости',
                cadastreSection: 'Пожалуйста, выберите тип кадастровой структуры',
                province: 'Пожалуйста, выберите регион',
                region: 'Пожалуйста, выберите район',
                addressAddEdit: 'Пожалуйста, введите адрес недвижимости',
                mibDebtorName: 'Пожалуйста, введите имя должника',
                mibLetterNumber: 'Пожалуйста, введите номер рекомендательного письма',
                mibLetterDate: 'Пожалуйста, выберите контрольную дату',
                areaTotal: 'Пожалуйста, укажите общую площадь земельного участка.',
                areaUnderConstruction: 'Пожалуйста, войдите в зону незавершенного строительства',
                areaUseful: 'Пожалуйста, укажите полезную площадь собственности',
                valueType: 'Пожалуйста, выберите тип значения',
                propertyType: 'Пожалуйста, выберите тип значения',
                evaluationRespectiveType: 'Пожалуйста, выберите подходящий тип недвижимости',
                cadastreSectionEdit: {
                    code: 'Пожалуйста, введите код',
                    nameUz: 'Пожалуйста, введите текст на узб',
                    nameRu: 'Пожалуйста, введите текст на ru'
                },
                cadastreBuildingEdit: {
                    section: 'Пожалуйста, выберите тип кадастровой структуры',
                    code: 'Пожалуйста, введите код',
                    nameUz: 'Пожалуйста, введите текст на узб',
                    nameRu: 'Пожалуйста, введите текст на ru',
                    recoveryField: 'Пожалуйста, выберите значение восстановления',
                    capitalGroup: 'Пожалуйста капиталлик гурухини танланг'
                },
                cadastreBuildingFieldEdit: {
                    code: 'Пожалуйста, введите код',
                    nameUz: 'Пожалуйста, введите текст на узб',
                    nameRu: 'Пожалуйста, введите текст на ru'
                },
                cadastreBuildingDepreciationFieldEdit: {
                    code: 'Пожалуйста, введите код',
                    nameUz: 'Пожалуйста, введите текст на узб',
                    nameRu: 'Пожалуйста, введите текст на ru'
                },
                cadastreBuildingFieldReferenceEdit: {
                    code: 'Пожалуйста, введите код',
                    nameUz: 'Пожалуйста, введите текст на узб',
                    nameRu: 'Пожалуйста, введите текст на ru'
                },
                reasonDesc: 'Пожалуйста, введите причину отмены',
                evlContractAmount: 'Пожалуйста, введите сумму контракта',
                realEstateDocs: 'Загрузить документы!',
                taxType: 'Тип',
                configAmount: 'Ценность'
            },
            land: {
                title: 'Недвижимость - Расчет рыночной стоимости земельного участка'
            },
            action: {
                evaluate: 'Конец оценки',
                confirm: 'Подтверждение',
                reevaluate: 'Переоценка',
                pending: 'Отмена',
                espSign: 'ЭЦП подписать',
                bindAppraiser: 'Передать оценщику',
                sendReportToMIB: 'Отправить отчет в МИБ',
                evaluationAnalogGet: 'Оценка',
                appraiserEspSign: 'Оценить подписание ЭЦП',
                submitForEvaluation: 'Отправить на оценку',
                bindAgent: 'Передайте агенту',
                evlComparativeReference: 'Маълумотнома PDF',
                bindComplement: 'Тўлдирувчига бериш'
            },
            esp: {
                title: 'Подписание недвижимости через ЭЦП',
                invoice: 'Подпись ЭЦП на счете-фактуре',
                invoiceEspInfo: '(Перед подписанием прочтите счет)',
                report: 'Подпись ЭЦП на отчете',
                reportEspInfo: '(Прочтите отчет перед подписанием!)',
                reportDownload: 'Подождите, пока загрузится отчет!',
                contractDownload: 'Подождите, контракт загружается!'
            },
            appraiserReportEsp: {
                title: 'Подписание через ЭЦП, оценщика недвижимости',
                report: 'Подпишите отчет через ЭЦП',
                reportEspInfo: '(Прочтите отчет перед подписанием!)',
                field: {
                    selectEsp: 'Выберите ключ'
                }
            },
            regression: {
                action: {
                    addCategories: 'Уй жой категория'
                }
            },
            cadastreDetails: {
                title: 'Кадастровые данные',
                buildingSectionTypeValue: "Категория",
                province: "Провинция",
                region: "Регион",
                mfyName: "Маҳалла",
                streetName: "Улица",
                address: "Адрес",
                cadastreNumber: "Кадастровый номер дома",
                owner: "Субъект",
                totalUsableArea: 'Общая площадь',
                floor: "На каком этаже",
                floorNumber: "Этаже ",
                landArea: "Общая площадь земли",
                buildingArea: "Площадь застройки",
                infoText: "Если в данных обнаружена ошибка, нажмите кнопку «Обновить»."
            },
            mapStatus: {
                open: 'Новый',
                pending: 'Ожидающий',
                reject: 'Отменено',
                done: 'Исправлено',
                inProgress: 'В процессе'
            }
        },
        building: {
            titleAddEdit: 'Здание недвижимости',
            edit: {
                title: 'Введите данные о здании в собственность'
            },
            field: {
                buildingType: 'Выберите тип здания',
                buildingTypeCategory: 'Категория типа здания',
                name: 'Название здания',
                madeYear: 'Год, когда здание было построено',
                floors: 'Кол-во этажей в здании',
                area: 'Площадь застройки (м2)',
                height: 'Общая высота здания (м)',
                heightInner: 'Внутренняя высота здания(м)',
                volume: 'Размер здания (м3)',
                earthquakePoint: 'Коэффициент сейсмостойкости',
                businessCoefficient: 'Коэффициент предпринимательства',
                foundation: 'Бино пойдевори',
                wall: 'Стены здания',
                roofCloseType: 'Способ закрытия крыши здания',
                floorsMiddleType: 'Между этажами здания',
                floorType: 'Поли здание',
                doorsAndWindows: 'Двери и окна',
                halfTimerFrame: 'Заполнение фахверка каркасных стен',
                standsAndColumns: 'Основания и колонны',
                additionalValues: 'Дополнительные значения',
                depreciation: 'Физическая амортизация',
                depreciationConstructiveElements: 'Физическая амортизация конструктивных элементов (%)',
                photosToSubmit: 'Загрузить фото здания',
                auxiliaryBuilding: 'Вспомогательное здание',
                attachedTo: 'Который пристроен к зданию',
                description: 'Мысли'
            },
            validation: {
                buildingType: 'Пожалуйста, выберите тип здания',
                name: 'Пожалуйста, введите название здания',
                floors: 'Пожалуйста, введите количество этажей в здании',
                area: 'Пожалуйста, войдите в строящуюся зону',
                height: 'Пожалуйста, введите общую высоту здания',
                volume: 'Пожалуйста, введите размер здания',
                earthquakePoint: 'Пожалуйста, выберите коэффициент сейсмостойкости',
                businessCoefficient: 'Пожалуйста, выберите бизнес-коэффициент',
                depreciationPercent: 'Введите физический износ элементов конструкции',
                customField: 'Пожалуйста {0}введите',
                customFieldSelect: 'Пожалуйста {0}введите',
                attachBuilding: 'Пожалуйста указать, к какому зданию он пристроен',
                cadastreBalance: 'Пожалуйста введите кадастровую или балансовую стоимость',
                heightInner: 'Пожалуйста введите внутреннюю высоту здания'
            },
            comparison: {
                title: 'Строительство недвижимости - сравнительный подход',
                titleInner: 'Элементы сравнения'
            },
            coordination: {
                title: 'Согласование недвижимости'
            },
            comparisonIncome: {
                title: 'Строительство недвижимости - доходный подход'
            }
        },
        payment: {
            list: 'Список платежей',
            add: 'Добавить платеж',
            edit: 'Изменить платеж',
            delete: 'Удалить платеж'
        },
        report: {
            title: 'Отчеты',
            usersTitle: 'Отчет персонал',
            clientsTitle: 'Отчет клиенты',

            date: {
                startDate: 'С даты',
                endDate: 'До даты'
            },
            category: {
                appraisers: {
                    code: 'ББ',
                    label: 'Транспортные средства и оборудование (оценщики)'
                },
                appraisersBuilding: {
                    code: 'БК',
                    label: 'Недвижимость (Оценщики)'
                },
                agents: {
                    code: 'АБ',
                    label: 'Транспортные средства и оборудование'
                },
                agentsBuilding: {
                    code: 'АК',
                    label: 'Недвижимость'
                },
                legalAccounting: {
                    code: 'ҲА',
                    label: 'Авто и инструменты'
                },
                legalAccountingBuilding: {
                    code: 'ҲК',
                    label: 'Недвижимость '
                },
                legalAssetReport: {
                    code: 'ҲА',
                    label: 'Смешанная недвижимость'
                },
                appraisersChart: {
                    code: 'БД',
                    label: 'Общая диаграмма'
                },
                agentChart: {
                    code: 'Аге',
                    label: 'Агент диаграмма'
                },
            },
            field: {
                agents: 'Агенты',
                bankName: 'Банк',
                mibDepartment: 'Отдел MIB',
                sspDepartment: 'Отдел ССП',
                fullName: 'Ф.И.О',
                mibDebtorName: 'Имя должника',
                createdDate: 'День',
                region: 'Территория',
                name: 'Наименование объекта проверки',
                evaluationPurpose: 'Цель оценки',
                car: 'Автотранспорт',
                building: 'Недвижимость',
                fitment: 'Основные инструменты',
                payment: 'Оплата',
                salary: 'Зарплата',
                quantity: 'Число',
                evaluationPrice: 'Оценка цен',
                paid: 'Падение',
                unpaid: 'Не впитывается',
                objectOfBank: 'Объект из банк',
                objectOfMib: 'Объект из MIB',
                objectOfSSP: 'Объект из ТПП',
                objectType: 'Тип объекта',
                province: 'Провинция',
                district: 'Область',
                ownerClient: 'Владелец недвижимости',
                governmentNum: 'Государственный номер',
                accountNumber: 'Номер и дата счета',
                paymentDate: 'Оплачено',
                customsAdministration: 'Таможенное управление',
                trafficAccidents: 'Дорожный транспорт',
                organization: 'Заявитель',
                spentTime: 'Время, потраченное на оценку',
                objectNumber: 'Оценка номер объекта',
                showReport: 'Презентация отчета (для e-baholash.uz)',
                confirmedDate: 'Дата завершения',
                spenedIsHours: 'Потраченное время',
                spenedToTime: 'Отведенное время',
                by: 'На',
                pays: 'Оплаченный',
                unPaid: 'Неоплаченный',
                paymentStatus: 'Статус платежа',
                paymentStatusAll: 'Это все',
                paymentStatusPaid: 'Оплаченный',
                paymentStatusUnPaid: 'Неоплаченный',
                paymentStatusSalary: 'Статус заработной платы',
                online: 'E-Baxolash сайт',
                inside: 'В себе',
                android: 'Android',
                api_mib: 'API_MIB',
                salePropertyStatus: 'Статус недвижимости на продажу',
                salePropertyStatusNONE: 'Непостроенные',
                salePropertyStatusSOLD: 'Проданные',
                salePropertyStatusUnPaid: 'Не проданные',
                showConclusion: 'Заключения показывать (для e-baholash.uz)',
            }
        },
        config: {
            title: 'Установка',
            autoConfig: 'Авто установка',
            permission: 'Настройки доступа',
            rentalRates: 'Ставки аренды',
            reEvaluate: {
                title: 'Переоценка',
                name: 'Название группы',
                index: 'Индекс',
                byProvinces: 'Группы регионов',
                productionAndNonProduction: 'Производственные и непроизводственные объекты (10000-10018)',
                constructions: 'Здания (20000-20382)',
                transfer_devices: 'Передаточные устройства',
                machinery_and_equipment: 'Механизмы и оборудование (40000-49303)',
                vehicles: 'Транспортные средствав  (50000-50709)',
            },
            contractRegion: 'Основные договора',
            contractAmount: 'Контракт суммы',
            currency: 'Қурсы валют ',
            populationIncome: {
                title: 'Средний доход населения',
                titleList: 'Список средних доходов населения',
                edit: {
                    title: 'Средний доход населения'
                }
            },
            product: {
                title: 'Продукт установка',
            },
            productCategory: {
                title: 'Категория продукта',
                titleList: 'Список категорий продукт',
                edit: {
                    title: 'Категория продукта'
                }
            },
            products: {
                title: 'Махсулотлар',
                productCategory: {
                    title: 'Тармоқ (Махсулот категорияси)',
                    titleList: 'Тармоқлар(Махсулот категорияси) руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                productSubCategory: {
                    title: 'Суб категорияси',
                    titleList: 'Суб категорияси руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                productManufacture: {
                    title: 'Марка',
                    titleList: 'Махсулот маркаси руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                productModel: {
                    title: 'Модел',
                    titleList: 'Модели руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                macroeconomicIndicators: {
                    title: 'Макроиқтисодий кўрсаткичлар',
                    titleList: 'Макроиқтисодий кўрсаткичлар руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                customs: 'Божхона божи',
                country: 'Мамлакат',
                measurement: 'Ўлчов бирликлари',
                status: 'Статус (Фаол/Ўчирилган)'
            },
            tender: 'Тендер сумма',
            companiesTariff: 'Компании Тариф',
            appraiserSalary: {
                title: "Настройки заработной платы оценщиков",
                titleList: 'Заработная плата оценщиков',
                titleAdd: "Добавьте зарплаты оценщиков",
                titleEdit: 'Изменить заработную плату оценщиков',
                agents: 'Агенты',
                appraiser: 'Оценщик',
                salary: 'Зарплата(сўм)',
                edit: {
                    title: 'Категория продукта'
                }
            },
            gasDevicePrice: {
                title: "Установка платы за газовое оборудование",
                titleList: 'Перечень платы за газовое оборудование',
                titleAdd: "Добавить плату за газовое оборудование"
            },
            yearIndex: {
                title: "Индексы по годам",
                titleList: 'Список индексов по годам',
                titleAdd: "Добавить круглогодичные индексы"
            },
            monthIndex: {
                title: "Индексы по месяцам",
                titleList: 'Список индексов по месяцам',
                titleAdd: "Добавляйте индексы по месяцам"
            },
            expert2: {
                title: 'Настроить - Эксперт2'
            },
            syncDbHistory: 'Synchronization DB Histories',
            evaluationAmount: 'Изменение оценочных значений'
        },
        messages: {
            company: {
                success: 'Компания профайли муваффақиятли сақланди',
                error: 'Компания профайлини сақлашда хатолик юз берди',
            },
            list: {
                empty: 'Нет данных'
            },
            combo: {
                empty: 'Нет данных'
            },
            common: {
                error: 'Ошибка',
                errorOccurred: 'Произошла ошибка',
                success: '',
                warning: 'Предупреждение',
                saved: 'Сохранено',
                requiredField: 'Пожалуйста, введите значение',
                delete: {
                    confirm: 'Вы действительно хотите удалить этот {0}?',
                },
                reallyWant: 'Вы действительно хотите {0}?',
                removeFile: 'Файл успешно удален!',
                deleteConfirm: 'Сиз ҳақиқатдан ўчирмоқчимисиз?',
                deleteSuccess: 'Муваффақиятли ўчирилди',
                deleteError: 'Ўчиришда хатолик юз берди'
            },
            realEstate: {
                success: 'Имущество успешно поддерживалось',
                error: 'Произошла ошибка при обслуживании собственности',
                statusSuccess: 'Статус недвижимости успешно изменен',
                statusWarning: 'Вам не разрешено менять свой статус недвижимости',
                statusError: 'При изменении статуса объекта произошла ошибка.',
                showReportSuccess: 'Отчет о недвижимости разрешен на e-baholash.uz!',
                showCancelReportSuccess: 'Разрешение на просмотр отчета о недвижимости на e-baholash.uz отозвано!',
                showReportError: 'Произошла ошибка при просмотре отчета о недвижимости на e-baholash.uz',
                deleteConfirm: 'Вы действительно хотите удалить это свойство?',
                deleteSuccess: 'Свойство было успешно удалено',
                deleteError: 'При удалении свойства произошла ошибка',
                reportWarning: 'Вы уверены, что этот отчет точен?',
                appraiserReportSignEsp: 'В отчете нужно поставить ЭЦП, если уверены! Нажмите кнопку «Подтвердить», чтобы вставить!',
                appraiserEspSuccess: 'Внесение ЭЦП в отчет успешно завершено.',
                appraiserEspSuccessInfo: 'Вы нажимаете кнопку «Подтвердить», чтобы вернуться в главное меню!',
                employmentCoefficientField: {
                    deleteConfirm: 'Вы действительно хотите удалить эту информацию?',
                    deleteSuccess: 'Данные были успешно удалены',
                    deleteError: 'Произошла ошибка при удалении данных'
                }
            },
            auto: {
                success: 'Автотранспорт муваффақиятли сақланди',
                statusSuccess: 'Автотранспорт муваффақиятли ўзгартирилди',
                statusError: 'Автотранспортни ўзгартиришда хатолик юз берди',
                statusWarning: 'Автотранспорт статусини ўзгартиришга сизда рухсат йўқ',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу Автотранспортни ўчирмоқчимисиз?',
                deleteSuccess: 'Автотранспорт муваффақиятли ўчирилди',
                deleteError: 'Автотранспортни ўчиришда хатолик юз берди',

            },
            fitment: {
                success: 'Асосий восита муваффақиятли сақланди',
                statusSuccess: 'Асосий восита муваффақиятли ўзгартирилди',
                statusError: 'Асосий воситани ўзгартиришда хатолик юз берди',
                statusWarning: 'Асосий восита статусини ўзгартиришга сизда рухсат йўқ',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу Асосий воситани ўчирмоқчимисиз?',
                deleteSuccess: 'Асосий восита муваффақиятли ўчирилди',
                deleteError: 'Асосий воситани ўчиришда хатолик юз берди',

            },
            building: {
                success: 'Дом недвижимости успешно сохранился.',
                error: 'Ошибка в обслуживании здания недвижимости.',
                deleteConfirm: 'Вы действительно хотите снести это здание?',
                deleteSuccess: 'Здание было успешно удалено',
                deleteError: 'При удаление здания произошла ошибка'
            },
            map: {
                success: 'Район был успешно сохранен',
                error: 'Произошла ошибка при сохранении области',
                warning: {
                    title: 'Предупреждение',
                    text: 'Недвижимость не найдена!'
                }

            },
            reEvaluation: {
                success: 'Имущество успешно сохранено',
                error: 'Произошла ошибка при сохранении свойства',
                deleteConfirm: 'Вы действительно хотите удалить это свойство?',
                deleteSuccess: 'Свойство было успешно удалено',
                deleteError: 'Произошла ошибка при удалении свойства'
            },
            uzCard: {
                cancelCardTransConfirm: 'Вы действительно хотите отменить эту транзакцию? Примечание: эта сумма будет возвращена при отмене бронирования!'
            },
            regression: {
                analogMsg: 'Количество аналогов редкое. Введите дополнительный аналог!'
            },
            fixedExpense: {
                success: 'Фиксированная стоимость успешно сохранена',
                error: 'Произошла ошибка при сохранении фиксированной стоимости',
                deleteConfirm: 'Вы действительно хотите удалить это свойство?',
                deleteSuccess: 'Фиксированная стоимость успешно удалена',
                deleteError: 'При удалении фиксированной стоимости произошла ошибка'
            },
            ipotekaPaymentTransaction: {
                success: 'Платеж успешно сохранен',
                error: 'Произошла ошибка при сохранении платежа',
                listError: 'Произошла ошибка в списке платежей',
                deleteConfirm: 'Вы действительно хотите удалить этот платеж?',
                deleteSuccess: 'Платеж успешно отменен',
                deleteError: 'Произошла ошибка при удалении платежа',
                timeUp: 'Время вышло'
            },
            cadastreHistorical: {
                updateSuccess: 'Кадастровая информация успешно сохранена',
            },
            companyTariff: {
                success: 'Тарифы компаний успешно поддерживаются.',
                error: 'Произошла ошибка при сохранении тарифов компаний.',
                deleteConfirm: 'Вы действительно хотите отменить тарифы этих компаний?',
                deleteSuccess: 'Тарифы компаний успешно отменены',
                deleteError: 'Произошла ошибка при отключении тарифов компаний'
            },
            expert2: {
                statusSuccess: 'Эксперт2 успешно сохранен',
                error: 'Эксперт2 произошла ошибка во время хранения',
                validate: 'Саклашни амалга оширинг!',
                statusError: 'Эксперт2 статусини ўзгартиришда хатолик юз берди',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам ушбу Эксперт2ни ўчирмоқчимисиз?',
                deleteSuccess: 'Эксперт2 муваффақиятли ўчирилди',
                deleteError: 'Эксперт2 ўчиришда хатолик юз берди'
            },
            director: {
                success: 'Директор успешно сохранено.',
                error: 'Произошла ошибка при сохранении директора'
            },
            client: {
                success: 'Мижоз муаффақиятли сақланди',
                fail: 'Бу мижоз системага олдин қўшилган!',
                notFound: 'Мижоз аниқланмади!',
                error: 'Хатолик юз берди!',
                searchSuccess: 'Мижоз топилди!'
            }
        },
        auto: {
            label: 'Автотранспорт',
            taxes: 'Налоги',
            taxesAdd: 'Добавить налоги',
            customsRate: 'Таможенные ставка',
            roadCost: 'Дорожные расходы',
            vat: 'НДС',
            expensesForCustomsClearance: 'Расходы на таможенное оформление',
            autoDocs: 'Автотранспортни бахолаш учун тақдим қилинадиган хужжатлар',
            exciseTax: 'Акцизный налог',
            profitTaxRate: 'Ставка налога на прибыль',
            rentRate: 'Арендная ставка',
            discountLimit: 'Лимит для скидки',
            exciseTaxForCountry: 'Акцизный налог для государства',
            countryAdd: 'Добавить государство',
            coefficientForDilapidation: 'Уделний весь',
            addCoefficientForDilapidation: 'Добавить уделний весь',
            autoToEvaluate: 'Введите автотранспорты для оценки',
            addAuto: 'Добавить автотранспорт',
            editAuto: 'Изменить автотранспорт',
            name: 'Наименование автотранспорта',
            selectAuto: 'Выберите автотранспорт',
            deviceType: 'ТВ.тип',
            madeYear: 'Дата выпуска автотранспорта',
            overpassKm: 'Пробег автотранспорта (км)',
            engineNum: 'Номер двигателя автотранспорта',
            bodyNum: 'Номер кузова автотранспорта',
            shasseNum: 'Номер шассе автотранспорта',
            fullWeight: "Полная масса автотранспорта (кг)",
            autoColor: 'Свет автотранспорта',
            additionalConveniences: 'Дополнительные расходы после выкупа',
            highWeight: 'Весь автотранспорта без груза',
            technicalConditionOfCar: 'Техникческое состояние автотранспорта',
            dilapidationValueByExpert: 'Определить обветшание автотранспорта путем эксперта',
            texPassportNum: 'Номер техпаспорта автотранспорта',
            adress: 'Адрес автотранспорта указанный в техпаспорт',
            electricalComponents: 'Электрические части',
            tires: 'Шины',
            hasNo: 'Имееться/Не имееться',
            steeringMechanisms: 'Механизмы руля',
            engine: 'Двигатель',
            transmissionBox: 'Каробка передачи',
            saloonParts: 'Салон',
            technicalConditionReport: 'Техникческое состояние',
            photos: 'Фото автотранспорта',
            texPassport: 'Техпаспорт автотранспорта',
            title: 'Введите данние автотранспорт!',
            titleAct: 'Данние автотранспорта!',
            success: 'Автотранспорт успешно оценен!',
            autoGasDevice: 'Газооборудование',
            autoGasDeviceName: 'Наименование газооборудования',
            autoGasDevicePrice: 'Цена газооборудования',
            autoGasDeviceDilapidation: 'Обветшание газооборудования',
            autoGasDeviceSource: 'URL сайта газооборудования',
            comparative: 'Определение ценности сравнительного подхода',
            comparativeLbl: 'Сравнительный подход',
            autoCalculationLabel: 'Расчеты по оценке автотранспорта',
            autoCorrectionTypeLabel: 'Соединение затратного и сравнительного потхода оценки',
            deleteConfirm: 'Действительно хотите ли вы удалить этот автотранспорт?',
            deleteSuccess: 'Автотранспорт успешно удален!',
            deleteError: 'Произолша ошибка при удалении автотранспорта',
            fuelType: 'Вид топлива',
            list: 'Список автотранспортных средств',
            approachName: 'Подходы',
            approach: {
                expense: 'Расходный',
                income: 'Доходный',
                comparative: 'Сравнительный',
                regression: 'Регрессионный'
            },
            autoLoses: {
                label: 'Авто-ущерб',
                list: 'Список авто'
            },
            isFixByIndexLabel: 'Киёсий ёндашув индекс буйича тузатиш бериш',
            autoManufacture: {
                label: 'Авто брендлар',
                list: 'Автотранспорт ишлаб чиқарувчилар',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                manufacture: 'Ишлаб чиқарувчи ташкилот номи',
                error: 'Ишлаб чиқарувчи ташкилот номи киритинг!'
            },
            carCategory: {
                label: 'Автотранспортлар категорияси',
                list: 'Автотранспорт категорияларининг рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                category: 'Автотранспорт категорияси',
                error: 'Автотранспорт категориясини киритинг!'
            },
            autoType: {
                label: 'Автотранспортлар турлари',
                list: 'Автотранспорт турларининг рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                type: 'Автотранспорт тури',
                error: 'Автотранспорт турини киритинг!',
                autoName: 'Автотранспорт номи',
                model: 'Машина модели',
                fuelType: 'Автотранспорт ёнилиги тури',
                createDate: 'Яратилган сана',
                country: 'Мамлакат',
                stopProduction: 'Бахолаш тури',
                typeOfCar: 'Авто тури',
                carPositions: 'Авто позиция',
                gearBoxType: 'Коробка передач',
                horsePower: 'Машина от кучи',
                engineCapacity: 'Двигател хажми',
                fullWeight: 'Машина тўла вазни (кг)',
                trackTypes: 'Юк транспорт тури',
                seatNumber: 'Ўриндиқлар сони',
                checkTrackedTire: 'Занжирли (Гусеницали)',
                checkCustomsTax: 'Божхона божи ва харажатларини ҳисобга олиш.',
                checkStopProduction: 'Ишлаб чиқаришдан олиб ташланган',
                rentType: 'Машина рентабиллиги',
                rentValue: 'Рентабиллик коэффициенти',
                categorization: 'Туркумлилиги',
                carryingCapacity: 'Юк оғирлиги (кг)',
                axletree: 'Ғилдирак ўқи'
            },
            autoPrice: {
                currency: 'Валюта',
                price: 'Автотранспорт нархи',
                pricingDate: 'Нарх ўрнатилган сана',
                source: 'Олинган манба'
            },
            carCoincidental: {
                label: 'Турдош автотранспортлар',
                list: 'Турдош автотранспортларнинг рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                coincidental: 'Турдош автотранспорт',
                autoTypeFullName: 'Автотранспорт номи',
                carCoincidentalFullName: 'Турдош автотранспорт номи',
                createDate: 'Киритилган сана',
                createUserName: 'Томонидан яратилган',
                error: 'Турдош автотранспортни киритинг!'
            },
            autoTexPassport: {
                label: 'Техпаспорти маълумотлари',
                list: 'Техпаспорти маълумотлари рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                texPassport: 'Техпаспорти',
                texPassportNumber: 'Автотранспорт техпаспорт номери',
                governmentNum: 'Автотранспорт давлат рақам белгиси',
                autoName: 'Автотранспорт номи',
                createDate: 'Киритилган сана',
                updateDate: 'Ўзгартирилган сана',
                createUserName: 'Томонидан киритилган',
                updateUserName: 'Томонидан ўзгартирилган',
                ownerName: 'Автотранспорт эгаси номи',
                engineNum: 'Автотранспорт двигател рақами',
                bodyNum: 'Автотранспорт кузов рақами',
                shasseNum: 'Автотранспорт шассе рақами',
                fullWeight: "Автотранспорт тўла вазни (кг)",
                madeYear: 'Автотранспорт чиққан йили',
                autoColor: 'Автотранспорт ранги',
                highWeight: 'Автотранспорт юксиз вазни (кг)',
                fuelType: 'Автотранспорт ёқилғи тури',
                address: 'Манзили',
                identificationNumber: "Автотранспорт эгаси ИНН рақам",
                pinflNumber: 'Автотранспорт эгаси ЖШШИР (ПИНФЛ) рақам',
                innOrPinflNumber: 'Автотранспорт эгаси (ПИНФЛ/ИНН) рақам',
                texPasDataStatus: 'Статус',
                birthDate: 'Автотранспорт эгаси тўғилган санаси',
                validation: {
                    minText: 'Ушбу майдон камида ',
                    minValid: ' та белгидан иборат бўлиш керак!',
                    maxText: 'Ушбу майдон ',
                    maxValid: ' та белгидан иборат бўлиш керак!',
                    birthDate: 'Мижоз тўғилган санасини керак!',
                    pinflNumber: 'Жисмоний шаҳснинг шаҳсий идентификация рақамини киритинг!',
                    identificationNumber: 'ИННни киритинг!',
                    texPassportNumber: 'Автотранспорт техпаспорт номерини киритинг!',
                    governmentNum: 'Автотранспорт давлат рақам белгисини киритинг!',
                    autoName: 'Автотранспорт номини киритинг!',
                    ownerName: 'Автотранспорт эгаси номини киритинг!',
                    engineNum: 'Автотранспорт двигател рақамини киритинг!',
                    bodyNum: 'Автотранспорт кузов рақамини киритинг!',
                    shasseNum: 'Автотранспорт шассе рақамини киритинг!',
                    fullWeight: 'Автотранспорт тўла вазнини киритинг!',
                    madeYear: 'Автотранспорт чиққан йилини киритинг!',
                    autoColor: 'Автотранспорт рангини киритинг!',
                    highWeight: 'Автотранспорт юксиз вазнини киритинг!',
                    fuelType: 'Автотранспорт ёқилғи турини киритинг!',
                    address: 'Манзилини киритинг!'
                }
            },
            newAutoPriceList: {
                label: 'Янги автотранспорт нархлари',
                list: 'Янги автотранспорт нархларнинг рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                newAutoPrice: 'Янги автотранспорт нархи',
                autoType: 'Автотранспорт',
                autoManufacture: 'Ишлаб чиқарувчи',
                createDate: 'Киритилган сана',
                pricingDate: 'Нарх ўрнатилган сана',
                createUserName: 'Томонидан яратилган',
                priceListFile: 'Прайст листни юкланг',
                error: 'Автотранспорт нархини киритинг!'
            },
            autoParts: {
                label: 'Авто эхтиёт кисмлар',
                list: 'Авто эхтиёт кисмлар рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                view: 'Кўриш',
                name: 'Эхтиёт кисм номи',
                measurement: 'Ўлчов бирликлари',
                createdDate: 'Яратилган сана',
                createdBy: 'Томонидан яратилган',
                error: 'Хато',
            },
            smallAutoPart: {
                label: 'Кичик эхтиёт кисмлар',
                list: 'Кичик эхтиёт кисмлар рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                view: 'Кўриш',
                error: 'Хато',
                price: 'Нархи',
                name: 'Кичик эхтиёт кисм номи',
                measurement: 'Ўлчов бирликлари',
                createdDate: 'Яратилган сана',
                createdBy: 'Томонидан яратилган'
            },
            autoPartsNormHours: {
                label: 'Автотранспорт қисмларини таьмир муддати нормалари',
                list: 'Автотранспорт қисмларини таьмир муддати нормалари рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                view: 'Кўриш',
                error: 'Хато',
                price: 'Автотранспорт қисмларининг нархи',
                upgrade: 'Автотранспорт қисмларини янгилаш муддати нормаси',
                repair: 'Автотранспорт қисмларини таьмир муддати нормаси',
                source: 'Автотранспорт қисмларини нархи манбаси',
                autoPart: 'Автотранспорт қисмларини',
                autoType: 'Автотранспорт',
                createdDate: 'Яратилган сана',
                createdBy: 'Томонидан яратилган'
            },
            plus: {
                list: 'Авто Баҳолаш Плюс',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                view: 'Кўриш',
                autoInformationVisible: 'Автотранспорт маълумотлари',
            }
        },
        accounting: {
            title: 'Бухгалтериский учет',
            titleLegalAccounting: 'Юридический отчет',
            account: {
                category: {
                    accountBook: {
                        code: 'A',
                        label: 'Транспортные средства и оборудование'
                    },
                    accountBuildingBook: {
                        code: 'К',
                        label: 'Недвижимость'
                    },
                    accountAsset: {
                        code: 'А',
                        label: 'Смешанная недвижимость'
                    }
                },
                accountBook: 'Бухгалтерская книга',
                organization: 'Организация',
                province: 'Провинция',
                district: 'Область',
                city: 'Город',
                date: 'Дата',
                number: 'Номер',
                executiveJob: "Исполнительная работа",
                bankMFO: "МФО",
                accountNumber: "Номер счета",
                identificationNumber: "ИНН",
                pinflNumber: 'Жисмоний шаҳснинг шаҳсий идентификация рақами (ЖШШИР 14 рақам)',
                contract: 'Контракт',
                order: 'Заказ',
                report: 'Отчет',
                feeService: 'Плата за услугу (сўм)',
                invoice: 'Счёт фактура',
                jobName: 'Название выполненной работы',
                priceWithoutQQS: 'Цена без НДС (сўм)',
                qqs: 'НДС',
                totalAmountQQS: 'Общая сумма с НДС (сўм)',
                qqsRate: 'Ставкаси',
                qqsAmount: 'Сумма (сўм)',
                requirement: 'Требование',
                totalAmount: 'Общая сумма',
                including: 'Включая',
                principalDebt: "Основной долг",
                priceFine: "Штраф",
                pricePenny: "Пеня",
                paymentDocument: "Платежный документ",
                vatPayment: "НДС тўловлар",
                vatEnterPayment: "НДС киритиш",
                debtBalance: "Остаток долга",
                creditor: "Кредитор",
                amountPrice: "Сумма",
                debtor: "Дебитор",
                registrationPayDoc: "Оформление платежного документа",
                paymentSource: "Тип платежа",
                registrationPayDocList: "Список платежных документов",
                paymentDelayed: "Оплата просрочена",
                numberDays: "Количество дней",
                calculated: "Рассчитано",
                lostProfitOrDamage: "Упущенная прибыль или убыток",
                saleProperty: "Продажа имущества",
                propertyType: "Тип недвижимости",
                numberLot: "Большое число",
                saleDate: "День торговли",
                salesDateAndPrice: "Дата продажи и цена",
                sellingPrice: "Цена продажи",
                reportDateTotalNumberOfDays: "Общее количество дней до отчетной даты",
                paymentOfLastDate: "Крайний срок оплаты",
                accordingContract: "В соответствии с договором",
                decision1154: "12.05.1996 даги ПФ-1154 га мувофиқ",
                numberDaysLastDatePayment: "Количество дней до срока платежа",
                numberBorrowerDays: "Количество дней просрочки",
                residualBorrowingPennyFineLossNotIncluded: "Остаточная задолженность не включает штрафы, пени, убытки.",
                residualBorrowingPennyFineLossAlongWith: "Общая задолженность, включая штрафы, пени, убытки",
                physical: "Индивидуальный",
                legal: "Юридическое лицо",
                fullName: "Ф.И.О (Название организации)",
                passportNumber: "Серийный номер паспорта (Юридический адрес)",
                source: 'Источник',
                esp: "E-imzo",
                property: "Имущество",
                additionalCalculatedMoney: "Доначисленные средства (Общество)",
                societyFunds: "Основной капитал (Общество)",
                districtAndCity: 'Район и город',
                createdUserName: 'Кем было создано',
                objectType: 'Тип объекта',

            },
            accountMessages: {
                success: 'Успешно сохранено',
                error: 'Произошла ошибка при сохранении',
                fillAllFields: 'Заполните поля полностью',
            },
        },
        common: {
            users: 'Сотрудники',
            currency: 'Валюта',
            startDate: 'От',
            endDate: 'По',
            code: 'Код',
            comment: 'Примечания',
            name: 'Наименование',
            fullName: 'Полное наименование',
            shortName: 'Краткое наименование',
            add: 'Добавить',
            group: 'Группа',
            nameRU: 'Название (RU)',
            qty: 'Количество',
            inn: 'ИНН',
            inps: 'ИНПС',
            status: 'Статус',
            draft: 'Черновик',
            annul: 'Аннулировать',
            search: 'Искать',
            netAmount: 'Чистая сумма',
            total: 'Всего',
            login: 'Логин',
            password: 'Парол',
            smsCode: 'Смс код',
            transferMoney: 'Утгазиш',
            active: 'Актив',
            deactive: 'Ноактив',
            date: 'Сана',
            createdDate: 'Дата добавления',
            updateDate: 'Дата изменения',
            createdBy: 'Создано',
            evlPrice: 'Расчетная стоимость',
            paymentWithUzCard: 'Оплата с UzCard',
            createType: {
                ourselves: 'Ўзимизда',
                online: 'E-Baxolash сайти',
                android: 'Android',
                apiMib: 'API MIB',
                api_bank: 'API BANK',
                api_backend: 'API BACKEND',
                api_online: 'API ONLINE',
                api_exarid: 'API E-XARID',
                expert2: 'Эксперт 2'
            },
            evlStatus: {
                notReady: 'Тайёр эмас',
                pending: 'Хали кўрилмади',
                notFullyEvaluated: 'Жараёнда',
                confirmed: 'Тасдиқланган',
                rejected: 'Бекор қилинган',
                assignedToEvaluator: 'Бахоловчига бириктирилди',
                evaluated: 'Бахоланган',
                sentToComplement: 'Тўлдирувчига бириктирилди'
            }
        },
        map: {
            title: 'Карта',
            category: {
                drawPolygon: {
                    code: '',
                    label: 'Рисование границ недвижимости'
                },
                organizationMap: {
                    code: '',
                    label: 'Расположение недвижимости'
                }
            },
            realEstateType: 'Тип недвижимости',
            accommodation: 'Размещение',
            multiStoriedAccommodation: 'Многоэтажное жилье',
            landAreaAccommodation: 'Площадь земельного участка',
            noResidentialLand: 'Земельный участок нежилой',
            shop: 'Магазин',
            restaurantCafe: 'Ресторан-кафе',
            office: 'Офис',
            warehouse: 'Склад',
            leisureDatabases: 'Базы отдыха',
            buildingsProduction: 'Здания, предназначенные для производства',
            notProductionBuildings: 'Здания, не предназначенные для производства',
            otherBuildings: 'Другие'
        },
        eAppraisal: {
            title: 'Заявки',
            objectType: {
                realEstate: {
                    code: 'М',
                    label: 'Имущество (Плюса оценка)'
                },
                auto: {
                    code: 'A',
                    label: 'Авто (Плюса оценка)'
                },
                fitment: {
                    code: 'Б',
                    label: 'Другого средства (Плюса оценка)'
                },
                asset: {
                    code: 'A',
                    label: 'Смешанное имущество (Плюса оценка)'
                },
                autonc: {
                    code: 'ANC',
                    label: 'Онлайн авто NC'
                },
                order: {
                    code: 'ОБ',
                    label: 'Онлайн заявки'
                },
                expert2: {
                    realEstate: {
                        code: 'E2',
                        label: 'Недвижимость (Эксперт2)'
                    },
                    asset: {
                        code: 'E2',
                        label: 'Имущество (Эксперт2)'
                    },
                    fitment: {
                        code: 'E2Б',
                        label: 'Другого средства (Эксперт2)'
                    },
                    auto: {
                        code: 'E2A',
                        label: 'Авто (Эксперт2)'
                    }
                }
            }
        },
        asset: {
            name: 'Имущество',
            title: 'Список по оценкам имуществ',
            assetAdd: 'Добавить смешанной имущество',
            assetEdit: 'Изменить смешанной имущество',
            assetView: 'Посмотреть смешанной имущество',
            assetDocs: 'Предоставленные документы для оценки смешанной имуществ',
            passport: 'Копия пасспорта',
            document: 'Письмо руководителя организации',
            actOfSale: 'Акт',
            decision: 'Решение',
            playlist: 'Листы воспроизведения',
            assetToEvaluate: 'Вводите смешанной имущества для оценки',
            titleAddEdit: 'Оценить смешанной имущество',
            titleAddEditNotorious: 'Оценить смешанной имущество (Нежилое помещение)',
            titleAddEditResidential: 'Оценить смешанной имущество (Жилое помещение)',
            deleteConfirm: 'Действительно хотите ли вы удалить это смешанной имущество?',
            realEstateToEvaluate: 'Вводите недвижимость для оценки',
            statusSuccess: 'Статус смешанная имущества успешно изменён',
            statusWarning: 'У вас нет доступа изменить статус смешанная имущества',
            statusError: 'Произошла ошибка при изменении статуса смешанная имущества',
            deleteSuccess: 'Смешанное имущество успешно удален!',
            deleteError: 'Произолша ошибка при удалении смешанная имущества',
            esp: {
                title: 'Подпись смешанная имущества через ЭЦП',
                titleAppraiser: 'Подпись смешанная имущества через ЭЦП со стороны оценщика',
                invoice: 'Счет-фактура подписи (проверьте счет перед подписанием)',
                report: 'Подписание отчета на ЭЦП (проверьте отчет перед подписанием)',
                reportDownload: 'Пожалуйста, подождите, пока отчет загружается!',
                contractDownload: 'Пожалуйста, подождите, пока загружается контракт!'
            },
            code: 'A',
            plus: {
                code: 'A(+)',
                label: 'Имущество (плюс)'
            },
            titlePlusList: 'Список по оценкам имуществ (Оценка плюсом)'
        },
        business: {
            name: 'Бизнес',
            title: 'Список по оценкам Бизнес',
            add: 'Добавить Бизнес',
            edit: 'Изменить Бизнес',
            view: 'Посмотреть Бизнес',
            businessDocs: 'Предоставленные документы для оценки Бизнес',
            passport: 'Копия пасспорта',
            document: 'Письмо руководителя организации',
            actOfSale: 'Акт',
            decision: 'Решение',
            playlist: 'Листы воспроизведения',
            businessToEvaluate: 'Вводите Бизнес для оценки',
            titleAddEdit: 'Оценить Бизнес',
            titleAddEditNotorious: 'Оценить Бизнес (Нежилое помещение)',
            titleAddEditResidential: 'Оценить Бизнес (Жилое помещение)',
            deleteConfirm: 'Действительно хотите ли вы удалить это Бизнес?',
            realEstateToEvaluate: 'Вводите недвижимость для оценки',
            statusSuccess: 'Статус Бизнес успешно изменён',
            statusWarning: 'У вас нет доступа изменить статус Бизнес',
            statusError: 'Произошла ошибка при изменении статуса Бизнес',
            esp: {
                title: 'Подпись недвижимости через ЭЦП',
                invoice: 'Счет-фактура подписи (проверьте счет перед подписанием)',
                report: 'Подписание отчета на ЭЦП (проверьте отчет перед подписанием)',
                reportDownload: 'Пожалуйста, подождите, пока отчет загружается!',
                contractDownload: 'Пожалуйста, подождите, пока загружается контракт!'
            },
            financeResult: {
                success: 'Финансовый результат успешно сохранен',
            }
        },
        fitment: {
            name: 'Наименование другого средства',
            fitmentDocs: 'Бошқа мол-мулкни бахолаш учун тақдим қилинадиган хужжатлар',
            title: 'Введите данные другого средства',
            titleJewelry: 'Введите данные ювелирного изделия',
            fitmentToEvaluate: 'Введите другие средства для оценки',
            fitmentAdd: 'Добавить другие средства',
            jewelryAdd: 'Добавить ювелирные изделия',
            fitmentEdit: 'Изменить другие средства',
            brandName: 'Бренд другого средства',
            model: 'Модель другого средства',
            useWebSite: 'Источник',
            foreign: 'Учет таможенных пошлин',
            qty: 'Количество',
            um: 'Единица измерения',
            price: 'Цена',
            madeYear: 'Год производства',
            technicalCondition: 'Техникческое состояние',
            madeCountry: 'Государство производства',
            province: 'Область',
            partConditions: 'Общее состояние',
            photos: 'Фото',
            texPassport: 'Техпаспорт',
            texPassportNumber: 'Номер техпаспорта',
            aboutTexPassport: 'О техпаспорте',
            hallmark: 'Проба',
            weigh: 'Весь',
            metalType: 'Виды ювелирного изделия',
            gold: 'Золото',
            silver: 'Серебро',
            stoneName: 'Наименование камня',
            stonePrice: 'Цена камня',
            overlayCoefficient: 'Накладный коэффициент',
            deleteConfirm: 'Действительно хотите ли вы удалить это другое средство?',
            deleteSuccess: 'Другое средство успешно удален!',
            deleteError: 'Произолша ошибка при удалении другого средства',
            dilapidationValue: 'Обветшание',
            jewelery: 'Ювелирные изделия',
            fitmentType: 'Виды другого средства',
            address: 'Объект манзили',
            customsDuty: 'Таможенная пошлина',
            esp: {
                title: 'Подпись другое средства через ЭЦП',
                titleAppraiser: 'Подпись другое средства через ЭЦП со стороны оценщика',
                invoice: 'Счет-фактура подписи (проверьте счет перед подписанием)',
                report: 'Подписание отчета на ЭЦП (проверьте отчет перед подписанием)',
                reportDownload: 'Пожалуйста, подождите, пока отчет загружается!',
                contractDownload: 'Пожалуйста, подождите, пока загружается контракт!'
            }
        },
        settings: {
            otherConfig: 'Другая конфигурация',
            evaluationPrices: 'Цена отценки',
            efunctionTypesYim: 'Коэффициент в зависимости от вида деятельности'
        },
        reportGeneralDirector: {
            title: 'Отчет Генералний директор',
            category: {
                reportOfWorkDone: {
                    code: '',
                    label: 'Отчет о проделанной работе'
                },
                expenses: {
                    code: '',
                    label: 'Затраты компании',
                    name: 'Название стоимости',
                    paidDate: 'Дата оплаты',
                    companyExpenseType: 'Тип затрат',
                    paymentNumber: 'Номер платежного поручения',
                    paymentAmount: 'Сумма перевода',
                    description: 'Описание'
                },
                income: {
                    code: '',
                    label: 'Выручка компании',
                    name: 'Название дохода',
                    incomeDate: 'Дата получения',
                    incomingNumber: 'Кирим Раками',
                    incomeAmount: 'Размер дохода',
                    description: 'Описание'
                },
                realTimeWorkDone: {
                    code: '',
                    label: 'Работа в реальном времени'
                }
            },
            agents: 'Агенты',
            province: 'Провинция',
            organizationsOther: 'Другие организации',
            realEstate: 'Недвижимость',
            autoAndFitment: 'Авто и инструменты',
            quantity: 'Количество',
            mibDepartment: 'МИБ',
            sspDepartment: 'ССП',
            customsDepartment: 'ТАМОЖНЯ',
            bankDepartment: 'БАНК',
            autoLossesDepartment: 'ДТП',

        },
        reEvaluation: {
            name: 'Переоценка имущества',
            titleList: 'Перечень переоценки имущества',
            titleAddEdit: 'Переоценка имущества',
            add: {
                title: 'Введите информацию о переоцененной собственности'
            },
            edit: {
                title: 'Переоценка - это смена имущества'
            },
            view: {
                title: 'Переоценка недвижимости строительство',
                eAppraisalTitle: ' E-baholash: общая информация о недвижимости'
            },
            delete: {
                title: 'Удалить'
            },
            field: {
                oldRecoveryDate: 'Дата первоначального выздоровления',
                oldRecoveryReportNumber: 'Номер первоначального отчета о восстановлении',
                organizationName: 'Название организации',
                orgIdentificationNumber: 'Организация ИНН',
                docsToSubmit: 'Документы, поданные на переоценку имущества',
                docDocuments: 'Письмо-заявление',
                docApplication: 'Приложения',
                toReEvaluate: 'Введите недвижимость для переоценки',
                addItem: 'Добавление собственности',
                calcExcel: 'Учет в Excel'
            },
            item: {
                field: {
                    name: 'Название собственности',
                    stockCode: 'Код основных средств',
                    numberOfProperty: 'Количество объектов',
                    propertyNumber: 'Основной номер счета',
                    oldRecoveryAmount: 'Начальное значение восстановления',
                    depreciationAmount: 'Обесценивание',
                    balanceAcceptedDate: 'Дата принятия на баланс',
                    reEvaluateIndex: 'Индекс переоценки',
                    province: 'Область',
                    residualAmount: 'Остаточная стоимость'
                }
            },
            validation: {
                oldRecoveryDate: 'Пожалуйста выберите начальную дату восстановления',
                oldRecoveryReportNumber: 'Пожалуйста введите номер первоначального отчета о восстановлении',
                organizationName: 'Пожалуйста введите название организации, проводившей переоценку',
                orgIdentificationNumber: 'Пожалуйста введите организацию(ИНН)'
            }
        },
        finance: {
            name: 'Finance',
            titleListUzCard: 'Uzcard список транзакций',
            titleListUserBalance: 'Список баланса пользователя',
            uzCard: {
                transaction: {
                    code: 'UzC',
                    label: 'Uzcard транзакций',
                    status: {
                        wait: 'Ожидается',
                        paid: 'Оплаченный',
                        cancel: 'Отменено',
                        unknown: 'Неизвестный',
                    }
                }
            },
            ipoteka: {
                titleListDebit: 'Ipoteka cписок дебетовых операций',
                titleListCredit: 'Ipoteka список кредит транзакций',
                titleListCreditBind: 'Ipoteka список кредитных операций',
                getTransaction: 'Скачать транзакции Ipoteka-Bank',
                getTransactionConfirm: 'Вы действительно хотите загрузить эту транзакцию?',
                balanceAccounts: 'Посмотреть баланс в номерах счетов',
                balanceAccountsConfirm: 'Вы действительно хотите создать осадок?',
                balanceAccountsList: 'Список номеров счетов',
                bindToObject: 'Объединение объектов',
                rejectTransaction: 'Вернуть транзакцию',
                rejectReason: 'Причина возврата',
                titleListFixedExpenses: 'Список фиксированной стоимости',
                titleIpotekaPaymentList: 'Ipoteka Список платежных операций',
                titleListFixedReadyTransferExpenses: 'Список операций по фиксированным расходам (ежемесячно, еженедельно)',
                transaction: {
                    code: 'IPO',
                    creditLabel: 'Ipoteka Кредитные операции',
                    debitLabel: 'Ipoteka Дебетовые операции',
                    status: {
                        paid: 'Оплаченный',
                        unknown: 'Неизвестный',
                    }
                },
                fixedExpenses: {
                    titleNew: 'Добавить новую фиксированную стоимость',
                    titleEdit: 'Постоянное изменение стоимости',
                    expenseType: 'Тип затрат',
                    titleExpenseTypeList: 'Список типов затрат',
                    expenseTypeAdd: 'Новый тип счета',
                    expenseTypeEdit: 'Изменить тип счета',
                    fixedExpensePaymentPeriodType: 'Регулярный платеж',
                    fixedExpensePaymentDate: 'Дата постоянного платежа'
                },
                paymentTransaction: {
                    titleNew: 'Добавить новый платеж',
                    titleEdit: 'Изменение платежа',
                    confirmMsg: 'Хотите произвести оплату? Платеж не подлежит возврату',
                    draftMsg: 'Сделать Черновик?',
                    creditName: "Название кредитной организации",
                    creditINN: "Кредит ИНН",
                    creditAccount: "Номер кредитного счета",
                    creditBankName: "Название кредитного банка",
                    creditMFO: "Кредит МФО",
                    debetName: 'Дебетовое наименование организации',
                    debetINN: 'Дебет ИНН',
                    debetMFO: 'Дебет МФО',
                    debetAccount: 'Дебет Номер счета',
                },
                field: {
                    debitCredit: 'Дебет/Кредит',
                    debit: 'Дебет',
                    credit: 'Кредит',
                    IID: 'IID',
                    DATE_ENTER: 'DATE_ENTER',
                    DATE_PROV: 'DATE_PROV',
                    DATE_DOC: 'DATE_DOC',
                    NUM_DOC: 'NUM_DOC',
                    ACC_DB: 'ACC_DB',
                    BANK_DB: 'BANK_DB',
                    NAME_DB: 'NAME_DB',
                    ACC_CR: 'ACC_CR',
                    BANK_CR: 'BANK_CR',
                    NAME_CR: 'NAME_CR',
                    SUMMA: 'SUMMA',
                    PURPOSE: 'PURPOSE',
                    INN_DB: 'INN_DB',
                    INN_CR: 'INN_CR',
                    contractNumber: 'Договор №',
                    reminderAfterSharing: 'Остаток',
                    bound: 'привязанный',
                    not_fully_bound: 'не польно привязанный',
                    spare_money: 'Ортиқча пул',
                    not_bound: 'не привязанный',
                    wrong_transfer: 'неправильный перевод',
                    fixedExpensesName: 'Название фиксированной стоимости',
                    payDate: "Дата оплаты",
                    payAmount: "Сумма платежа",
                    creditName: "Название организации",
                    creditINN: "ИНН",
                    creditAccount: "Номер счета",
                    creditBankName: "Название банка",
                    creditMFO: "МФО",
                    documentNumber: "Номер документа",
                    documentId: "ID документа",
                    transactionId: "ID Трансакция",
                    operationType: "Тип проводки",
                    creditPurpose: "Назначение платежа",
                    codeBudget: "Код Бюджет",
                    nameBudget: "Бюджет имя",
                    accountBudgetIncome: "Доход бюджета аккаунта",
                    innBudget: "Бюджет ИНН",
                }
            },
            paynet: {
                transaction: {
                    code: 'PayN',
                    label: 'Список транзакций'
                }
            },
            field: {
                cardNumber: 'Номер карты',
                phoneNumber: 'Номер телефона',
                yourMobileNumber: 'Твой номер телефона',
                contractNumber: 'Номер контракта',
                payerName: 'Плательщик',
                source: 'Источник',
                amount: 'Оплаченная сумма',
                performTime: 'Время оплаты',
                status: 'Статус',
                action: 'Процесс',
                checkedDate: 'Дата проверки:',
                target: 'Тип объекта',
                date: 'Дата платежа',
                createDate: 'Дата создания',
                beginDate: 'Чило(от)',
                endDate: 'Чило(до)',
                search: 'Поиск',
                objectId: 'Объект ID',
                contractAmount: 'Сумма контракта',
                user: 'Пользователь'
            },
            action: {
                checkTrans: 'Проверять',
                cancelTrans: 'Возвращение'
            },
            userBalance: {
                code: 'UB',
                label: 'Балансы'
            },
            deposit: {
                titleList: 'Депозит агентов',
                code: 'АД',
                appraiser: {
                    title: 'Депозит сотрудника',
                    code: 'ХД',
                },
                regionalLeader: {
                    title: 'Депозит территориального лидера',
                    code: 'ХРД',
                },
                cashTransfer: "Перевод денег",
                cashAmount: "Сумма денег",
            },
            balance: {
                titleList: 'Балансы сотрудника',
                code: 'БС',
                cashTransfer: "Перевод денег",
                cashAmount: "Сумма денег",
                fullName: 'Ф.И.Ш',
                statusBalance: 'Статус Баланс',
                user: 'Фойдаланувчи',
                date: 'Дата'
            },
            salary: {
                titleList: 'Ходимлар иш ҳақи',
                code: 'ИХ',
                cashTransfer: "Пул ўтказиш",
                cashAmount: "Пул миқдори",
                fullName: 'Ф.И.Ш',
                statusBalance: 'Статус Баланс',
                user: 'Фойдаланувчи',
                date: 'Сана'
            }
        },
        newRealEstate: {
            name: 'Новая недвижимость',
            titleList: 'Список новой недвижимости',
            titleListNotorious: 'Список новой недвижимости (Нотурар жой)',
            titleListResidential: 'Список новой недвижимости (Турар жой)',
            report: 'Отчет по новой недвижимости',
            income: {
                title: 'Расчет доходного подхода',
                rentTitle: 'Счет аренды',
                valEs: 'Один квадратный метр в год. минимальная ставка за метр, (Эс)',
                valKk: 'Коэффициенты по типу конструкции здания(Кк)',
                valKh: 'Коэффициент использования присоединенной площади(Кҳ)',
                valKt: 'Удобство использования в коммерческих целях (Кт)',
                valTs: 'Один квадратный метр в год. базовая ставка арендной платы за метр, (Тс)'
            },
            validation: {
                buildingType: 'Пожалуйста выберите цель использования',
                repairCondition: 'Пожалуйста выберите режим ремонта',
                wall: 'Пожалуйста введите тип строительства',
                constructionCompletion: 'Пожалуйста введите завершение строительства',
                usefulAreaValid: 'Полезное поле введено неверно!',
                architecturalStyle: 'Пожалуйста введите архитектурный стиль!'
            },
            field: {
                plus: {
                    category: 'Категория & Субкатегория',
                    createdBy: 'Заказчик',
                    source: 'Источник',
                    assignedDateToAgent: 'Дата, привязанная к агенту',
                    assignedDateToEvaluator: 'Дата прикрепления к оценщику',
                    confirmedDate: 'Дата окончания срока',
                    agent: 'Агент',
                    buildingType: 'Категория',
                    subBuildingType: 'Суб категория',
                    landComparison: 'Расчет земельного участка',
                    mfy: "МФЙ",
                    microRegionSelected: "Выбор пункт назначения"
                }
            }
        },
        tender: {
            name: 'Тендеры',
            title: 'Гонорары территориальным менеджерам за услуги, предоставленные на тендерах',
            title2: 'Описание работы по идентификации',
            titleListTypeWork: 'Тип выполняемой работы',
            titleListPriceCity: 'По городу(сўм)',
            titleListPriceDistrict: 'По району(сўм)',
            description: 'Комментарий',
            delivereEnvelope: 'Конверт топшириш',
            tenderParticipation: 'Участие в тендере и транспортные расходы',
            concludingContract: 'Заключение договора',
            realEstate: 'Недвижимость',
            fitment: 'Прочие виды собственности',
            auto: 'Автомототранспорт воситаси',
            addEbaholash: 'Войти в программу',
            printEbaholash: 'Заключение оценки',
            calculation: 'Бухгалтерия',
            users: 'Сотрудники',
            validation: {
                buildingType: 'Пожалуйста выберите цель использования',
                repairCondition: 'Пожалуйста, выберите тип ремонта',
                wall: 'Пожалуйста введите тип строительства'
            }
        },
        regionalLeader: {
            code: 'RL',
            titleList: 'Список региональных лидеров',
            addNew: "Добавить регионального лидера",
            fullName: 'И.Ф.О',
            province: 'Провинция',
            address: 'Адрес',
            description: 'Комментарий',
            internalPhoneNumber: 'внутренний номер телефона',
            successSaved: 'Регионального лидера удалось сохранить',
        },
        companyTariff: {
            listTitle: "Список тарифов компаний",
            addNew: "Добавить тариф компании",
            titleEdit: 'Изменение тарифов компаний',
            companyTariffType: "Тип тарифа",
            name: "Название",
            qty: "Количество",
            amount: "Сумма",
            measurementType: "Единица измерения",
            description: "Комментарий"
        },
        companyManage: {
            title: "Управление компанией",
            companyPersonalCabinet: {
                code: 'CM',
                label: 'Личный кабинет компании',
            },
            companyOrder: {
                title: 'Список пакетов компаний',
                feeService: 'Плата за услугу (сўм)',
                paidAmount: 'Оплаченная сумма (сўм)',
                addNew: "Заказ услуги",
                tariff: 'Тариф',
                companyClient: 'Клиент компании',
                contractNumber: 'Номер договора',
                addTariff: 'Добавить тариф',
                editTariff: 'Изменить тариф',
                addPieceSale: 'Добавить шт',
                editPieceSale: 'Изменить шт'
            }
        },
        depositSalary: {
            title: "Зарплатные Депозиты",
            appraiserSalary: {
                label: 'Заработная плата оценщиков',
                code: '',
                addTitle: 'Добавьте зарплаты оценщиков',
                editTitle: 'Изменить заработную плату оценщиков',
                addNewDepositSalary: "Перевести заработную плату на депозит ",
                appraiser: 'Оценщик',
                maxDepositAmount: " с невозможно внести депозит больше",
            },
            usersSalary: {
                label: 'Заработная плата персонала',
                code: '',
                paidAmount: 'Оплаченная сумма (сўм)'
            }
        },
        userBalancePaymentTransaction: {
            title: "Оплата с баланса пользователя",
            contractNumber: "Контракт номер",
            summa: "Сумма",
            payer: "Плательщик",
            objectId: "Object Id",
            objectName: "Название объекта",
            smsSend: "Отправить SMS",
            inputSmsCode: "Sms Code",
            pay: "Платить"
        },
        paymentBalance: {
            title: "Оплата с баланса",
            contractNumber: "Контракт номер",
            summa: "Сумма",
            payer: "Плательщик",
            objectId: "Номер объекта, оцениваемого оценщиком",
            objectName: "Название объекта",
            smsSend: "Отправить СМС",
            inputSmsCode: "Sms Code",
            pay: "Оплатить"

        },
        finance2: {
            name: 'Finance 2',
            universalBank: {
                titleListCredit: 'Universal Bank Список кредитных операций',
                titleListDebit: 'Universal Bank Список дебетовых операций',
                titleTransactionList: 'Universal Bank список платежных операций',
                getBalance: 'Посмотреть баланс в номерах счетов',
                balanceAccount: 'Остаток на счетах',
                balanceAccountsConfirm: 'Вы действительно хотите увидеть останки?',
                getAccountTransactionConfirm: 'Вы действительно хотите загрузить эту транзакцию?',
                transaction: {
                    debit: {
                        code: 'UBD',
                        label: 'Universal Bank Дебит'
                    },
                    credit: {
                        code: 'UBC',
                        label: 'Universal Bank Кредит',
                        action: {
                            getAccountCredit: 'Скачать кредитные операции'
                        }
                    },
                    payment: {
                        code: 'UBP',
                        label: 'Universal Bank платежные операции',
                        action: {
                            balanceViewClose: 'Выход'
                        }
                    }
                },
                paymentTransaction: {
                    add: {
                        title: 'Добавить новый платеж'
                    }
                }
            }
        },
        expert2: {
            name: 'Эксперт 2',
            titleList: 'Эксперт2 список',
            titleAdd: 'Эксперт2 добавить',
            titleEdit: 'Эксперт2 изменить',
            titleEAppraisalRealEstateView: 'Е-баҳолаш эксперт2 посмотреть недвижимость',
            titleEAppraisalAssetView: 'Е-баҳолаш эксперт2 посмотреть имущество',
            titleFitment: {
                view: 'Е-баҳолаш эксперт2 Асосий воситани кўриш',
                list: 'Онлайн эксперт2 Асосий воситалар руйхати'
            },
            titleAuto: {
                view: 'Е-баҳолаш эксперт2 Автотранспортни кўриш',
                list: 'Онлайн эксперт2 Автотранспортлар руйхати'
            },
            list: {
                code: 'E',
                label: 'Эксперт2 список'
            },
            add: {
                title: 'Эксперт2 введите информацию'
            },
            edit: {
                title: 'Эксперт2 изменение'
            },
            field: {
                name: 'Имя объекта',
                organizationName: 'Название организации',
                userBank: "Банк ходими телефон рақами",
                bankName: "Банк номи",
                deleteConfirm: 'Сиз ҳақиқатдан ҳам ўчириб ташламоқчимисиз?',
                deleteSuccess: 'Муваффақиятли ўчирилди',
                deleteError: 'Ўчиришда хатолик юз берди',
                evlGoalType: "Цель оценки",
                status: 'Статус',
                action: 'Процесс',
                documents: 'Программные документы',
                act: 'Эксперт',
                approaches: 'Подходы',
                orgInn: "ИНН (Организация оценки)",
                owner: "Собственник",
                ownerInn: 'ИНН (Собственника)',
                ownerType: {
                    physical: 'Физическое лицо',
                    legal: 'Юридическое лицо'
                },
                createdDate: 'Дата добавления',
                province: 'Выберите область',
                region: 'Выберите регион',
                address: 'Адрес объекта',
                reportNumber: 'Регистрационный номер отчета об оценке',
                evlEstimatedDate: 'Дата оценки',
                docsToSubmit: 'Документы для подачи',
                docCadastre: 'Копия кадастрового документа',
                docReport: 'Копия отчета "Оценки"',
                docPhotos: 'Фотографии здания',
                source: '',
                buildingCount: 'Количество литров объекта оценки',
                evlObjectCount: 'Количество литров объекта оценки',
                fitmentMachinesToolsCount: 'Количество машин и оборудования',
                fitmentOthersCount: 'Количество других',
                agent: 'Агент',
                assetCoordination: 'Эксперт2 Координация смешанного имущества',
                assetToEvaluate: 'Введите смешанные имущества',
                assetEvaluations: 'Оценки смешанного имущества'
            },
            validation: {
                reference: {
                    sortOrder: 'Пожалуйста введите последовательность',
                    comment: 'Пожалуйста введите мнение'
                },
                approachCost: 'Харажат ёндашув тўлдирилмаган!',
                approachComparative: 'Қиёсий ёндашув тўлдирилмаган!',
                approachIncome: 'Даромад ёндашув тўлдирилмаган!'
            },
            approach: {
                expense: 'Расходный подход',
                income: 'Доходный подход',
                comparative: 'Сравнительный подход'
            },
            status: {
                notReady: 'Не готово',
                pending: 'Не обоработано',
                notFullyEvaluated: 'В процессе',
                confirmed: 'Утверждено',
                rejected: 'Отменено',
                assignedToEvaluator: 'Прикреплен к оценщику',
                evaluated: 'Оценен',
            },
            calculated: {
                expense: 'Оценка объектининг харажат ёндашувида бахолаш натижаси',
                coordination: 'Модификация результатов оценки'
            },
            action: {
                finish: 'Конец оценки',
                pending: 'Отправить на оценку',
                reject: 'Отказ',
                open: 'Новый',
                inCorrection: 'В исправлении'
            }
        },
        director: {
            list: {
                code: 'D',
                label: 'Список директоров'
            },
            listTitle: "Список директоров",
            addNew: "Добавить директор",
            titleEdit: 'Изменение директор',
            description: "Изох"
        },
        companyRegistrationCertificate: {
            title: 'Свидетельство о регистрации компании',
            addNew: "Добавить свидетельство о регистрации компании",
            fullName: 'Полное имя',
            shortName: 'Короткое имя',
            registrationDate: 'Дата регистрации',
            registrationNumber: 'Регистрационный номер',
            picture: 'Копия свидетельство о регистрации компании',
            address: 'Адрес компании',
            givenBy: 'Предоставлено'
        },
        employees: {
            list: {
                code: 'X',
                label: 'Ходимлар'
            },
            listTitle: "Ходимлар рўйхати",
            addNew: "Ходим қўшиш",
            titleEdit: 'Ходим ўзгартириш',
            description: "Изох"
        },
        appraiserHelpers: {
            list: {
                code: 'Б',
                label: 'Баҳоловчи ёрдамчилари'
            },
            listTitle: "Баҳоловчи ёрдамчилари рўйхати",
            addNew: "Баҳоловчи ёрдамчиси қўшиш",
            titleEdit: 'Баҳоловчи ёрдамчиси ўзгартириш',
            description: "Изох",
            employeeName: 'Исми/Шарифи',
            email: 'Е-майл',
            mobilePhone: 'Мобил телефон',
            roleNames: 'Мансаби',
            createDate: 'Киритилган сана',
            updateDate: 'Охирги ўзгартирилган сана',

        }
    }
}
export default messages;
